import React, { useEffect, useRef } from 'react';
import { useApp } from '../../context/AppContext';

function LogoutPage() {
  const { logout, isAuthenticated } = useApp();
  const called = useRef(false);

  useEffect(() => {
    if (!called.current) {
      called.current = true;
      logout && logout();
    }
  }, [logout]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f4f7f9',
      fontFamily: "'Poppins', sans-serif",
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        color: '#94a3b8',
        fontSize: '0.9rem',
      }}>
        <span style={{
          width: 20, height: 20,
          border: '2px solid #e2e8f0',
          borderTop: '2px solid #10ac84',
          borderRadius: '50%',
          display: 'inline-block',
          animation: 'spin 0.7s linear infinite',
        }} />
        Signing out...
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default LogoutPage;
